/**
 * Policy tip type
 * @public
 */
export const enum PolicyTipType {
    none = 0,
    notify = 1,
    block = 2,
    notifyAndBlock = 3,
    blockSharing = 4
}

/**
 * @public
 */
export const enum RetentionPolicyType {
    none,
    record
}
